// src/components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css'; // Create this CSS file for footer specific styles

function Footer() {
  return (
    <footer>
      &copy; 2025 IronBhai. All rights reserved. |
      <Link to="/refund-policy">Refund</Link> |
      <Link to="/terms-and-conditions">Terms</Link> |
      {/* <Link to="/shipping-policy">Shipping</Link> | */}
      <Link to="/privacy-policy">Privacy</Link> |
      <Link to="/copyright-notice">Copyright Notice</Link>
    </footer>
  );
}

export default Footer;
